/**
 * @generated SignedSource<<d21e6c4b3a57a8000e5887f196683565>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FolderItemLabel = "AGENDA" | "MINUTES" | "%future added value";
export type SignatureEnvelopeState = "CANCELLED" | "CERTIFYING" | "COMPLETED" | "COMPLETING" | "SIGNING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useItemHandleFragment$data = {
  readonly __typename: string;
  readonly announcementDate?: ISO8601DateTimeString | null;
  readonly announcer?: {
    readonly id: string;
    readonly name: string;
  };
  readonly color?: {
    readonly dark: string;
    readonly light: string;
  };
  readonly content?: {
    readonly __typename: "ExternalBridge";
    readonly id?: string;
    readonly url?: URIString;
  } | {
    readonly __typename: "File";
    readonly id: string;
    readonly mimeType: string;
    readonly name: string;
    readonly url: URIString;
  } | {
    readonly __typename: "Form";
    readonly id?: string;
    readonly questions?: ReadonlyArray<{
      readonly id: string;
      readonly text: string;
    }>;
  } | {
    readonly __typename: "InternalBridge";
    readonly id?: string;
    readonly url?: URIString;
  } | {
    readonly __typename: "Page";
    readonly data?: UnknownJSON | null;
    readonly id?: string;
    readonly title?: string;
  } | {
    readonly __typename: "PendingFile";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id: string;
  readonly label?: FolderItemLabel | null;
  readonly lastModifiedAt?: ISO8601DateTimeString;
  readonly link?: {
    readonly item: {
      readonly content?: {
        readonly __typename: "File";
        readonly name: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly id?: string;
      readonly name?: string;
    } | null;
  } | null;
  readonly name?: string;
  readonly ownershipEvent?: {
    readonly id: string;
  } | null;
  readonly ownershipFolders?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    }>;
  };
  readonly ownershipSpace?: {
    readonly id: string;
  };
  readonly pins?: ReadonlyArray<{
    readonly context: string;
    readonly id: string;
    readonly label: string | null;
  }> | null;
  readonly publishedAt?: ISO8601DateTimeString | null;
  readonly signatureEnvelope?: {
    readonly id: string;
    readonly status: SignatureEnvelopeState;
  } | null;
  readonly space?: {
    readonly id: string;
  };
  readonly thumbnail?: {
    readonly url: URIString;
  } | null;
  readonly uploadGroup?: {
    readonly publishedAt: {
      readonly utcDate: DateString ;
      readonly utcTime: TimeOfDayString;
    };
    readonly publisher: {
      readonly name: string;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "VaultItemAccessDetails_node">;
  readonly " $fragmentType": "useItemHandleFragment";
};
export type useItemHandleFragment$key = {
  readonly " $data"?: useItemHandleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemHandleFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "Event",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Thumbnail",
  "kind": "LinkedField",
  "name": "thumbnail",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v8/*: any*/),
          (v6/*: any*/)
        ],
        "type": "File",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModifiedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    (v8/*: any*/),
    (v6/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "PendingFile",
  "abstractKey": null
},
v15 = [
  (v1/*: any*/),
  (v6/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useItemHandleFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "ownershipSpace",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "ownershipEvent",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "last",
              "value": 1
            }
          ],
          "concreteType": "FolderConnection",
          "kind": "LinkedField",
          "name": "ownershipFolders",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Folder",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": "ownershipFolders(last:1)"
        }
      ],
      "type": "HasOwnerPermissionsInterface",
      "abstractKey": "__isHasOwnerPermissionsInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "announcementDate",
          "args": null,
          "kind": "ScalarField",
          "name": "publishedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Member",
          "kind": "LinkedField",
          "name": "announcer",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AnnouncementLink",
          "kind": "LinkedField",
          "name": "link",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v1/*: any*/),
                    (v5/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v4/*: any*/),
                      "type": "Folder",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v4/*: any*/),
                      "type": "FolderItem",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "content",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": (v4/*: any*/),
                              "type": "File",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "AnnouncementAttachment",
                      "abstractKey": null
                    }
                  ],
                  "type": "Node",
                  "abstractKey": "__isNode"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Announcement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "AnnouncementAttachment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "MemberDetailsAttachment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        (v10/*: any*/),
        (v11/*: any*/),
        (v7/*: any*/)
      ],
      "type": "Folder",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        (v12/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                }
              ],
              "type": "Page",
              "abstractKey": null
            },
            (v13/*: any*/),
            (v14/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormQuestion",
                  "kind": "LinkedField",
                  "name": "questions",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "text",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Form",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v15/*: any*/),
              "type": "ExternalBridge",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v15/*: any*/),
              "type": "InternalBridge",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Pin",
              "kind": "LinkedField",
              "name": "pins",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "context",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v12/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "HasPinsInterface",
          "abstractKey": "__isHasPinsInterface"
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SignatureEnvelope",
          "kind": "LinkedField",
          "name": "signatureEnvelope",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "SignableInterface",
      "abstractKey": "__isSignableInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VaultItemAccessDetails_node"
        },
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "VaultUploadGroup",
          "kind": "LinkedField",
          "name": "uploadGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DateTime",
              "kind": "LinkedField",
              "name": "publishedAt",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "utcDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "utcTime",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Member",
              "kind": "LinkedField",
              "name": "publisher",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "VaultItem",
      "abstractKey": null
    },
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatar_member"
        }
      ],
      "type": "Member",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        (v7/*: any*/)
      ],
      "type": "Vault",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Color",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "light",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dark",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Space",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "ec9ca93abb097451b369ee3c5686a7ab";

export default node;
